module.exports = __webpack_public_path__ + "static/media/login_bg_6_1920x1080.c4c6de18.jpg";